import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { Menu } from '../../Menu/index.js'
import { AddImageModal } from './AddImageModal.js'
import { INSERT_IMAGE_COMMAND } from './../plugins/ImagePlugin.js'
import { Button } from '../../Button/index.js'
import { useEffect, useState } from 'react'
import { useUploadFile } from '../../../hooks/useUploadFile.js'
import { InlineFileInput } from '../../InlineFileInput/index.js'
import { SelectUploadedFileModal } from './SelectUploadedFileModal.js'

export const SelectImageOptions = ({ disabled, size }) => {
  const [editor] = useLexicalComposerContext()
  const [menuOpen, setMenuOpen] = useState(false)
  const [file, setFile] = useState<{ src: string } | null>(null)

  const { handleFileInputChange, status, progress, newSrc } = useUploadFile()

  useEffect(() => {
    if (file) {
      editor.update(() => {
        editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
          src: file.src,
          caption: '',
        })
      })
    }
  }, [file])

  return (
    <Menu onOpen={() => setMenuOpen(true)} onClose={() => setMenuOpen(false)}>
      <Menu.Trigger>
        <IconButton
          tooltip={menuOpen ? null : 'Add Image'}
          size={size}
          icon="image"
          trailChevron="down"
          disabled={disabled}
        />
      </Menu.Trigger>
      <Menu.Items>
        <InlineFileInput
          multiple={false}
          onChange={handleFileInputChange((file) => {
            setFile({ src: file.src })
            Menu.Close()
          })}
        >
          <Button
            variant="ghost"
            leadIcon="arrow-up"
            width="full"
            style={{ '& > *': { justifyContent: 'start' } }}
          >
            Upload new file
          </Button>
        </InlineFileInput>
        <SelectUploadedFileModal
          setFile={(file) => {
            if (file.src) {
              setFile({ src: file.src })
            }
          }}
        >
          <Button
            leadIcon="image"
            variant="ghost"
            width="full"
            style={{ '& > *': { justifyContent: 'start' } }}
          >
            Pick from uploaded
          </Button>
        </SelectUploadedFileModal>
        <Menu.Separator />
        <AddImageModal
          urlOnly
          onSave={({ file, caption }) => {
            editor.update(() => {
              editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
                src: file.src,
                caption,
              })
            })
          }}
        >
          <Button
            leadIcon="link-on"
            variant="ghost"
            width="full"
            style={{ '& > *': { justifyContent: 'start' } }}
          >
            Insert from link
          </Button>
        </AddImageModal>
      </Menu.Items>
    </Menu>
  )
}
